import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { keyframes, styled } from '@mui/system'
import { TipPhase } from './SecurityTip.types'

const tipFadeIn = keyframes`
    from { opacity: 0; transform: translateY(4px); }
    to { opacity: 1; transform: translateY(0); }
`

const tipFadeOut = keyframes`
    from { opacity: 1; transform: translateY(0); }
    to { opacity: 0; transform: translateY(-4px); }
`

export const TipWrapper = styled('div')<{ phase: TipPhase }>`
    width: min(420px, 80vw);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    animation: ${({ phase }) => (phase === 'in' ? tipFadeIn : tipFadeOut)} 400ms
        ease both;
`

export const Kicker = styled(Typography)<{ theme?: TTheme }>`
    && {
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.greys[600]};
    }
`

export const Body = styled(Typography)<{ theme?: TTheme }>`
    && {
        line-height: 1.55;
        color: ${({ theme }) => theme.colors.greys[800]};
        max-width: 380px;
    }
`

export const Dots = styled('div')`
    margin-top: 12px;
    display: flex;
    gap: 6px;
    justify-content: center;
`

export const Dot = styled('span')<{ isActive: boolean; theme?: TTheme }>`
    width: ${({ isActive }) => (isActive ? '14px' : '5px')};
    height: 5px;
    border-radius: ${({ isActive }) => (isActive ? '3px' : '50%')};
    background-color: ${({ isActive, theme }) =>
        isActive ? theme.colors.primary[200] : theme.colors.greys[100]};
    transition:
        background-color 0.2s ease,
        width 0.2s ease;
`
